import { Card, Flex, Typography } from 'antd';

const { Text } = Typography;

/**
 * Tarjeta de estado vacío para pasos del formulario.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title - Título.
 * @param {React.ReactNode} [props.description] - Descripción.
 * @param {React.ReactNode} [props.action] - Contenido del slot de acción.
 */
export const EmptyStateCard = ({ title, description, action }) => (
  <Card
    style={{
      backgroundColor: '#f5f5f5',
      borderColor: '#d9d9d9',
    }}
  >
    <Flex
      vertical
      gap='middle'
      justify='center'
      align='center'
      style={{ textAlign: 'center' }}
    >
      <Text strong style={{ fontSize: '1.1em' }}>
        {title}
      </Text>
      {description && (
        <Text type='secondary' style={{ maxWidth: '23em' }}>
          {description}
        </Text>
      )}
      {action}
    </Flex>
  </Card>
);
